import {RESULT_SORTS} from 'constants/PrimerConstants';

export enum FindPrimersOptions {
  FOLDERS = 1,
  SINGLE = 2,
  BASES = 3,
  WORKLIST = 4,
  TAG_SCHEMA = 5,
}

export const PLUS_STRAND_SORT_TEXT = 'Strand (+)';
export const MINUS_STRAND_SORT_TEXT = 'Strand (-)';
export const RESULT_SORT_TO_DISPLAY_NAME = {
  [RESULT_SORTS.LOCATION]: 'Location',
  [RESULT_SORTS.TEMPERATURE]: 'Temperature',
  [RESULT_SORTS.NAME]: 'Name',
  [RESULT_SORTS.STRAND_PLUS]: PLUS_STRAND_SORT_TEXT,
  [RESULT_SORTS.STRAND_MINUS]: MINUS_STRAND_SORT_TEXT,
  [RESULT_SORTS.PERCENT_MATCH]: 'Percent Match',
};
export type ResultSort = (typeof RESULT_SORTS)[keyof typeof RESULT_SORTS];
